
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
/* eslint-disable */
// @ts-ignore
import {copyText} from 'vue3-clipboard'
/* eslint-enable */
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import {
  RequestedAction,
  TextHintDto
} from "@moderrotech/servers-communication-library/src/types";
import _ from "lodash";
import ProgressBar from "@/components/ProgressBar.vue";
import { getTextDirection } from "@/helpers/string";

export default {
  components: { ProgressBar },
  setup() {
    const store = useStore();

    const textHint = computed(
      (): TextHintDto | null => store.state.session.textHint
    );

    const isUrl = (str: string) => {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    };

    const handleCopyClick = () =>
      copyText(textHint.value?.text, undefined, (error: any, event: any) =>
        error
          ? showToastError(i18n.global.t("call.error.textCopy"))
          : showToastSuccess(i18n.global.t("call.success.textCopy"))
      );

    const requestedRemoteActions = computed(
      (): { action: RequestedAction; payload?: any }[] | null =>
        store.state.session.requestedActions
    );

    const isPaused = ref(false);

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.pauseTextHint
        ),
      v => {
        if (v) {
          isPaused.value = true;
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.pauseTextHint
          );
        }
      }
    );

    return {
      isUrl,
      textHint,
      handleCopyClick,
      isPaused,
      handleProgressEnd: () => store.commit("session/UNSET_TEXT_HINT"),
      handleCloseClick: () => store.commit("session/UNSET_TEXT_HINT"),
      getTextDirection
    };
  }
};
